// localStorage keys the retired Calendly integration left (TGCLOUD-1390).
//
// 'code' is the one that matters. Dashboard copied window.location.search into
// it on every render, so it held whatever query string the app was last opened
// with, link tokens included: a patient's /questionnaire?fhq_token=..., a Sapio
// sign-in, a trial verification link. Its only reader was Calendly's OAuth
// step, and nothing ever removed it. 'calendly_token' and 'fetchEnabled' were
// Calendly's own.
//
// Nothing writes these keys any more, so this only clears what a device already
// holds. It can go, with its call in Dashboard.jsx, after a couple of releases.
export const RETIRED_STORAGE_KEYS = Object.freeze([
  'code',
  'calendly_token',
  'fetchEnabled'
]);

// Storage can be missing, or throw on access or on use (a private window,
// blocked site data, a sandboxed frame). None of that is worth failing a page
// load over, so each step is tried on its own.
export function forgetRetiredBrowserState() {
  let storage;
  try {
    storage = window.localStorage;
  } catch {
    return;
  }
  if (!storage) return;
  for (const key of RETIRED_STORAGE_KEYS) {
    try {
      storage.removeItem(key);
    } catch {
      // Leave this one and try the rest.
    }
  }
}
